import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconExclamation = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.833 4h-3.689l.312 11.05h3.066L13.833 4ZM10 18.155c.024.269.094.53.208.767.114.238.27.448.456.618.188.17.403.298.634.375.232.077.474.102.714.074.48.04.954-.127 1.325-.47.37-.341.608-.83.663-1.364a2.134 2.134 0 0 0-.666-1.355 1.716 1.716 0 0 0-1.322-.456 1.633 1.633 0 0 0-.711.067c-.231.075-.447.2-.634.369a1.996 1.996 0 0 0-.457.613 2.206 2.206 0 0 0-.21.762Z"
    />
  </svg>
);
const Memo = memo(SvgIconExclamation);
export default Memo;
